module.exports = __webpack_public_path__ + "img/trade-img2.6b28d140.png";